import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { useEffect, useMemo, useState } from 'react';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import { useDispatch } from 'react-redux';
import sleep from 'sleep-promise';

function List() {

    const profileFilter = chooseProfileFilter(); 
    const pathFrontEnd = '/governanceroom/sectors/';
    const paths = { 
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}governanceroom/sectors/delete`,
        endpointGroups: `${config.endpoints.backend}governanceroom/groups/getall`,
        endpointSubGroups: `${config.endpoints.backend}governanceroom/subgroups/getall`,
        endpointCities: `${config.endpoints.backend}governanceroom/cities/getall`,
        endpointNeighborhoods: `${config.endpoints.backend}governanceroom/neighborhoods/getall`,
        endpoint: `${config.endpoints.backend}governanceroom/sectors/getall`
    }

    const dispatch = useDispatch();
    const [filterValues, setFilterValues] = useState({});

    const handleChange = async (element) => {
        const target = element['target'];
        let filters = {...filterValues}
        if(target.name === 'governance_room_city_id'){
            filters.governance_room_group_id = '';
            filters.governance_room_sub_group_id = '';
        }
        if(target.name === 'governance_room_group_id'){
            filters.governance_room_sub_group_id = '';
        }
        filters = {...filters, [target['name']]: target['value']}
        setFilterValues(filters)
        await sleep(1000);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    };

    useEffect(() => {
        async function fetchSectors (){
            await sleep(500);
            dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
        }

        fetchSectors();
    }, [filterValues]);

    const filters = useMemo(() => ({
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        update_key: `${filterValues.governance_room_city_id}-${filterValues.governance_room_group_id}-${filterValues.governance_room_sub_group_id}-${filterValues.governance_room_neighborhood_id}`,
        handleSubmit: loadData,
        fields: [
            {
                name: 'governance_room_city_id',
                type: 'select',
                label: 'Município',
                handleChange,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointCities,
                    label: 'city_name',
                    value: 'id',
                    params: {
                        filter: {
                            where: {
                                profileFilter
                            }
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'governance_room_group_id',
                type: 'select',
                label: 'Grupo',
                handleChange,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGroups,
                    label: 'description',
                    value: 'id',
                    params: {
                        filter: {
                            governance_room_city_id: filterValues.governance_room_city_id,
                            profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'governance_room_sub_group_id',
                type: 'select',
                label: 'Sub-Grupo',
                handleChange,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointSubGroups,
                    label: 'description',
                    value: 'id',
                    params: {
                        filter: {
                            governance_room_city_id: filterValues.governance_room_city_id,
                            governance_room_group_id: filterValues.governance_room_group_id,
                            profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'governance_room_neighborhood_id',
                type: 'select',
                label: 'Bairro',
                handleChange,
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointNeighborhoods,
                    label: 'description',
                    value: 'id',
                    params: {
                        filter: {
                            governance_room_city_id: filterValues.governance_room_city_id,
                            governance_room_group_id: filterValues.governance_room_group_id,
                            governance_room_sub_group_id: filterValues.governance_room_sub_group_id,
                            profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            }
        ],
        values: {
            governance_room_group_id: filterValues.governance_room_group_id,
            governance_room_sub_group_id: filterValues.governance_room_sub_group_id,
            governance_room_city_id: filterValues.governance_room_city_id,
            governance_room_neighborhood_id: filterValues.governance_room_neighborhood_id

        }
    }), [filterValues]);
    
    const list = useMemo(() => {

        let list = { 
            labelTitle: 'Setores',
            showPrintButtons: false,
            fieldsShowOnDelete: ['sector_id', 'city_state_name'],
            filter:{
                governance_room_group_id: filterValues.governance_room_group_id,
                governance_room_sub_group_id: filterValues.governance_room_sub_group_id,
                governance_room_city_id: filterValues.governance_room_city_id,
                governance_room_neighborhood_id: filterValues.governance_room_neighborhood_id,
                profileFilter
            },
            formFilters: filters,
            columns: [
                {
                    name: 'city_state_name',
                    label: 'Cidade',
                    width: '25%'
                },
                {
                    name: 'neighborhood_name',
                    label: 'Bairro',
                    width: '25%'
                },
                {
                    name: 'sector_id',
                    label: 'Cod. Setor',
                    width: '20%'
                },
            ],
        }

        list = {...paths, ...list};
        return list;
        
    }, [filterValues]);

    const content = useMemo(() => (
        <CustomList list={{ ...list, ...paths }} />
    ), [list, filters]);

    const customListContainer = useMemo(() => (
    <CustomListContainer
        canAdd={false}
        pathAdd={paths.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={content}
    />
    ), [content, filters, list]);
    
    return (
        <div>
            {customListContainer}
        </div>
    );
}
export default List;